<template>
  <div class="app-container">
    <el-button type="primary" size="small" @click="goBack()">返回</el-button>
    <div style="padding-top: 10px"></div>
    <el-card>
      <el-form :model="slideImageDetail" ref="forumGroupSlideImageForm" style="width: 60%" v-loading="uploadLoading" >
        <el-form-item
            label="图片标题"
            label-width="90px"
            prop="title"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input v-model="slideImageDetail.title" maxlength="100" show-word-limit/>
        </el-form-item>
        <el-form-item label="选择图片" label-width="90px">
          <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                     :on-change="change2DisplayLocalImage" :auto-upload="false">
            <div style="text-align: left;">
              <el-image style="width: 100px; height: 100px"
                        :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(slideImageDetail.imageUrl)"
                        fit="scale-down">
                <template #error>
                  <p></p>
                </template>
              </el-image>
              <br/>
              <el-button size="small" type="primary">点击上传</el-button>
            </div>

            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label-width="90px" label="是否启用">
          <el-switch active-text="启用" inactive-text="未启用" v-model="slideImageDetail.isEnabled"></el-switch>
        </el-form-item>
        <el-form-item label="链接类型" label-width="90px" prop="linkType"
                      :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
          <el-select v-model="slideImageDetail.linkType">
            <el-option label="URL地址" :value="1"></el-option>
            <el-option label="直播信息" :value="2"></el-option>
            <el-option label="往期回顾" :value="3"></el-option>
            <el-option label="视频课程" :value="4"></el-option>
            <el-option label="超人圈话题" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="90px"
                      v-if="slideImageDetail.linkType === 2 || slideImageDetail.linkType === 3 || slideImageDetail.linkType === 4"
                      label="资源id"
                      prop="bindId"
                      :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
          <el-input-number v-model="slideImageDetail.bindId"></el-input-number>
        </el-form-item>
        <el-form-item
            v-else
            label="页面地址"
            label-width="90px"
            prop="linkUrl"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input v-model="slideImageDetail.linkUrl"/>
          <div class="el-upload__tip" style="color: #aaa">
            页面需要向开发人员定制，发布后将页面地址填写在此处
          </div>
        </el-form-item>
        <el-form-item label="目标群组" label-width="90px">
          <el-select v-model="slideImageDetail.forumGroupIdList" multiple filterable clearable
                     @change="onForumGroupIdListChange()">
            <!-- TODO -->
            <el-option :value="0" label="首页" :key="0"></el-option>
            <el-option v-for="item in forumGroupList" :value="item.forumGroupId" :key="item.forumGroupId"
                       :label="item.groupName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
            v-if="userDataType.length > 0"
            label="所属领域"
            label-width="90px"
            prop="userDataType"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-select v-model="slideImageDetail.userDataType" style="width: 100%">
            <el-option v-for="item in userDataType" :value="item.value" :label="item.name"
                       :key="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="updateSlideImage()">保存</el-button>
    </el-card>

  </div>
</template>

<script>
import {isVaild} from "@/utils/validate";
import {
  getForumGroupSliderImageOne,
  updateForumGroupSliderImage
} from "@/api/CarouselManagement/CarouselManagement";
import {handleRes} from "@/utils/handleRes";
import {getOSSUploadInfo} from "@/api/system/CSDocument/file";
import {uploadFile2OSS} from "@/utils/OSSUpload";
import {deepClone} from "@/utils";
import {getCloudUrl, getLocalFileURL} from "@/utils/urlutil";
import {getUserType} from "@/utils/userutil";
import {getAllForumGroupList} from "@/api/ultrasonic";

export default {
  name: "ForumGroupSlideImageDetail",
  async created() {
    this.userDataType = getUserType()
    await this.getAllForumGroupList()
    let queryId = this.$route.query.forumGroupSliderImageId
    if (isVaild(queryId)) {
      this.forumGroupSliderImageId = queryId
      this.getForumGroupSliderImageOne()
    }
  },
  data() {
    return {
      forumGroupSliderImageId: 0,
      slideImageDetail: {},
      uploadCoverFile: null,
      uploadCoverFileURL: "",
      userDataType: [],
      forumGroupList: [],//全部超人圈群组数据，用于发表时选择
      uploadLoading: false, // 上传加载开关
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getForumGroupSliderImageOne() {
      getForumGroupSliderImageOne({
        forumGroupSliderImageId: this.forumGroupSliderImageId
      }).then((res) => {
        handleRes(res, () => {
          this.slideImageDetail = res.data
          this.slideImageDetail.forumGroupIdList = this.slideImageDetail.forumGroupVoList.map(entity => {
            return entity.forumGroupId
          })
        })
      })
    },
    change2DisplayLocalImage(uploadFile) {
      this.$refs.uploadCoverRef.clearFiles();
      this.uploadCoverFile = uploadFile;
      this.uploadCoverFileURL = getLocalFileURL(uploadFile);
    },
    getImageUrl(path) {
      return getCloudUrl(path)
    },
    onForumGroupIdListChange() {
      this.$forceUpdate()
    },
    async getAllForumGroupList() {
      let res = await getAllForumGroupList({
        pageSize: 0
      })
      handleRes(res, () => {
        this.forumGroupList = res.data.rows
      })
    },
    updateSlideImage() {
      this.$refs["forumGroupSlideImageForm"].validate(async (valid) => {
        if (valid) {
          this.uploadLoading = true;
          let savepathParamsRes = await getOSSUploadInfo({
            DataType: "26",
            ID: "0",
          });
          if (!isVaild(savepathParamsRes)) {
            this.uploadLoading = false;
            return;
          }
          let savePathParams = savepathParamsRes.resultData

          //上传封面
          if (isVaild(this.uploadCoverFile)) {
            // printObj(this.uploadCoverFile.raw)
            let timestamp = new Date().valueOf();

            let uploadRes;
            let fileName;
            if (isVaild(this.uploadCoverFile)) {
              fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
              // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
              uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
                type: this.uploadCoverFile.raw.type
              }), fileName)
            }
            if (uploadRes.status === 0) {
              this.slideImageDetail.imageUrl = "/" + fileName
              // console.log(this.form.liveCover)
            } else {
              this.$message({
                type: "error",
                message: "上传失败"
              })
            }
            this.$refs.uploadCoverRef.clearFiles();
          }

          const params = deepClone(this.slideImageDetail);
          updateForumGroupSliderImage(params).then((res) => {
            handleRes(res, () => {
              this.$message('操作成功')
              this.getForumGroupSliderImageOne()
              this.uploadLoading = false;
            })
            this.dialogVisible = false
          });
        } else {
          this.$message({
            type: "error",
            message: "请完善数据",
          });
        }
      });
    }
  }
}
</script>

<style scoped>

</style>